import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type LoadingRegionProps = Omit<ComponentProps<'div'>, 'role' | 'aria-busy' | 'aria-label'>;

/**
 * The container for a skeleton: announced once as loading, so its placeholders need no
 * labels of their own. Wrap only the placeholders, never a real heading beside them.
 */
export const LoadingRegion = (props: LoadingRegionProps) => {
  const { t } = useTranslation('common');
  return <div {...props} role="status" aria-busy="true" aria-label={t('loading')} />;
};
